import { Component, Input } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { JobPosting } from '@app/models/recruiting/job-posting.model';
import { JobPostingLocationType } from '@models/recruiting/job-posting-location-type.model';

@Component({
    selector: 'app-location-type-select',
    templateUrl: './location-type-select.template.html',
    styleUrls: ['./location-type-select.style.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class LocationTypeSelectComponent {
    @Input() jobPosting: JobPosting = new JobPosting();
    @Input() locationTypes: JobPostingLocationType[] = [];

    selectedId: number | undefined = undefined;

    ngOnInit(): void {
        this.selectedId = this.jobPosting.jobPostingLocationTypeId ?? undefined;
    }

    locationTypeMeta: Record<string, { label: string; text: string }> = {
        'on-site': {
            label: 'forms.applicant-tracker.onSite',
            text: 'forms.applicant-tracker.onSiteHelperText',
        },
        remote: {
            label: 'forms.applicant-tracker.remote',
            text: 'forms.applicant-tracker.remoteHelperText',
        },
        hybrid: {
            label: 'forms.applicant-tracker.hybrid',
            text: 'forms.applicant-tracker.hybridHelperText',
        },
    };

    onSelected(event: MatSelectChange) {
        this.selectedId = event.value;
    }

    getLocationType() {
        if (!this.selectedId) {
            return null;
        }

        return this.locationTypes.find((item) => item.id === this.selectedId);
    }
}
